import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';

export default class NoInn extends Component {
  render() {
    return (
      <div className="page_margin30">
        <p>Уважаемый пользователь!</p>
        <p>
          Ваша учетная запись на Госуслугах не позволила определить Ваш идентификационный номер
          налогоплательщика&nbsp; (ИНН). ИНН необходим для работы с информационными системами ФНС
          России.
        </p>
        <p>Приносим извинения за доставленные неудобства!</p>
        <Link href={routeMap.login}>Вернуться к форме авторизации</Link>
      </div>
    );
  }
}
